import { render, staticRenderFns } from "./form-capturista.vue?vue&type=template&id=1472a9a0&"
import script from "./form-capturista.vue?vue&type=script&lang=js&"
export * from "./form-capturista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports